import * as React from 'react';
import PropTypes from "prop-types";
import {buildUpdate, hideClass} from "./sharedFunctions";
import {durationUnits} from "./data";

export class RateLimit extends React.Component {
  static propTypes = {
    rateLimit : PropTypes.object,
    onChange: PropTypes.func,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
  }

  constructor(props){
    super(props)

    this.state = {
      selectedDuration : this.getDuration(props.rateLimit.duration),
      selectedUnit : this.getUnit(props.rateLimit.duration)
    }
  }

  getDuration = (combined) => {
    return parseInt(combined.split(' ')[0])
  }

  getUnit = (combined) => {
    return combined.split(' ')[1]
  }

  toCombinedDuration = (duration, unit) => {
    return duration + ' ' + unit
  }

  onSelectUnit = (e) => {
    this.setState({selectedUnit: e.target.value},() => {
      const combinedDuration = this.toCombinedDuration(this.state.selectedDuration, this.state.selectedUnit)
      this.props.onChange(buildUpdate('value',{duration:combinedDuration},null,true))
    })
  }

  onUpdateDuration = (e) => {
    this.setState({selectedDuration: e.target.value},() => {
      const combinedDuration = this.toCombinedDuration(this.state.selectedDuration, this.state.selectedUnit)
      this.props.onChange(buildUpdate('value',{duration :combinedDuration},null,true))
    })
  }

  onUpdateLimit = e => {
    this.props.onChange(buildUpdate('value',{limit : parseInt(e.target.value)},null,true))
  }

  render() {
    const {rateLimit, onRemove} = this.props
    const {selectedUnit} = this.state
    const {duration, limit} = rateLimit
    const identifier = this.key
    return(
      <tr className={hideClass(rateLimit)}>
        <td>
          <div className="form-group">
            <label htmlFor={'config-' + identifier + '-duration'}>Duration:</label>
            <input name={'config-' + identifier + '-duration'} type="number" aria-label="Duration"
                   className="form-control" value={this.getDuration(duration)} onChange={this.onUpdateDuration}/>
          </div>
        </td>
        <td>
          <div className="form-group">
            <label htmlFor={'config-' + identifier + '-unit'}>Unit:</label>
            <select className="form-control" onChange={this.onSelectUnit} value={selectedUnit}>
              {durationUnits.map( unit => {
                return <option key={identifier+'-unit-'+unit.value} value={unit.value}>{unit.label}</option>
              })}
            </select>
          </div>
        </td>
        <td>
          <div className="form-group">
            <label htmlFor={'config-' + identifier + '-limit'}>Limit:</label>
            <input name={'config-' + identifier + '-limit'} type="number" aria-label="Domain Rate Limit"
                   className="form-control" value={limit} onChange={this.onUpdateLimit}/>
          </div>
        </td>
        <td style={{verticalAlign: 'middle'}}>
          {<span className="fas fa-trash-alt fa-lg pull-right instant-audit-config-editor__button--delete" onClick={() => onRemove(buildUpdate('value',null,null,true))}></span>}
        </td>
      </tr>
    )
  }
}
